<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th class="checkbox tableCheckbox">
            <input type="checkbox" id="checkAll" v-model="checkedAll" @change="onCheckedAll($event)">
            <label for="checkAll"><span class="blind">check all</span></label>
          </th>
          <th>{{locale.title}}</th>
          <!-- <th class="center">{{locale.table_createat}}</th> -->
          <th class="center">{{locale.table_updateat}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!list.length" class="noData"><td colspan="5">{{locale.reservation_nodata}}</td></tr>
        <tr v-else v-for="reservation in list" :key="reservation.id">
          <td class="checkbox tableCheckbox">
            <input type="checkbox" name="checkItem" :id="`check${reservation.id}`" :value="reservation.id" v-model="checkedItem" @change="onCheckedItem($event)">
            <label :for="`check${reservation.id}`"><span class="blind">check</span></label>
          </td>
          <td><router-link :to="{name: 'reservationItem', params: {id: reservation.id}}" class="subject">{{reservation.title}}</router-link></td>
          <!-- <td class="center date">{{date(reservation.created)}}</td> -->
          <td class="center date">{{date(reservation.updateat)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DATE from '@/common/date'

export default {
  name: 'ReservationList',
  props: [
    'locale',
    'init',
    'list'
  ],
  watch: {
    init (isInit) {
      if (isInit) {
        this.checkedItem = []
      }
    },
    checkedItem (ids) {
      this.$emit('checked', ids)
    }
  },
  data () {
    return {
      checkedItem: [],
      checkedAll: false
    }
  },
  methods: {
    date (date) {
      return DATE.toString(date)
    },
    onCheckedAll (e) {
      const checked = e.target.checked
      this.checkedAll = checked
      let allId = []
      if (checked) {
        this.list.forEach(x => {
          allId.push(x.id)
        })
      }
      this.checkedItem = allId
    },
    onCheckedItem (e) {
      const checked = e.target.checked
      if (!checked) {
        this.checkedAll = false
      }
    }
  }
}
</script>
